import { createFileRoute, notFound, redirect } from "@tanstack/react-router";
import { isChannelTabValue } from "@/features/study-group-channels/components/StudyGroupChannelsTabContent";

export const Route = createFileRoute("/study-group/$study-group-id/home/$tab")({
  beforeLoad: ({ params }) => {
    const { tab } = params;
    if (!isChannelTabValue(tab)) {
      throw notFound();
    }
    if (tab === "stream") {
      throw redirect({
        to: "/study-group/$study-group-id/stream",
        params: { "study-group-id": params["study-group-id"] },
        replace: true,
      });
    }
    switch (tab) {
      case "events":
        throw redirect({
          to: "/study-group/$study-group-id/events",
          params: { "study-group-id": params["study-group-id"] },
          replace: true,
        });
      case "link-list":
        throw redirect({
          to: "/study-group/$study-group-id/link-list",
          params: { "study-group-id": params["study-group-id"] },
          replace: true,
        });
      case "files":
        throw redirect({
          to: "/study-group/$study-group-id/files",
          params: { "study-group-id": params["study-group-id"] },
          replace: true,
        });
      case "info":
        throw redirect({
          to: "/study-group/$study-group-id/info",
          params: { "study-group-id": params["study-group-id"] },
          replace: true,
        });
    }
    throw redirect({
      to: "/study-group/$study-group-id/stream",
      params: {
        "study-group-id": params["study-group-id"],
      },
      replace: true,
    });
  },
  component: () => null,
});
